import { operatorsModel } from '../outfitter'
import { involvedPartyModel } from '../damage-waiver-cases/involved-parties/involved-party-model'
import { repairInfoFragment } from './repair-info-fragment'
import { damageWaiverCaseModel } from './damage-waiver-case-model'
import { partFragment } from '../damage-waiver-cases/parts-order/part-fragment'
import { z } from 'my-zod'
import { operatorAddressFragment } from '../../utilities/address'
import { advancedReviewInfoFragment } from './advanced-review-info-fragment'
import { vehiclesModel } from '../../fleet-operations/vehicle'
import { modelsModel } from '../../fleet-operations/model'
import { partsOrderModel } from './parts-order/parts-order-model'

// @ts-ignore
export const damageWaiverCaseReportView = damageWaiverCaseModel
  .omit({
    shortId: true,
    vehicleId: true,
    customerWaiverIds: true,
    repairInfo: true,
    advancedReviewInfo: true,
    ownerUserId: true,
    createdUserId: true,
    lastModifiedByUserId: true,
    assignedUserId: true,
    assignedTeam: true,
    riskSpecialistId: true,
    attachments: true
  })
  .augment({
    ...advancedReviewInfoFragment.partial().shape,
    primaryLead: advancedReviewInfoFragment.shape.primaryLead.nullable(),
    corVelClaimNumber: advancedReviewInfoFragment.shape.corVelClaimNumber.nullable(),
    pssReleased: advancedReviewInfoFragment.shape.pssReleased.nullable(),
    legalReleased: advancedReviewInfoFragment.shape.legalReleased.nullable(),
    ...repairInfoFragment.omit({ deductibleLevel: true, currency: true, repairStatus: true }).augment({
      deductibleLevel: repairInfoFragment.shape.deductibleLevel.nullable(),
      currency: repairInfoFragment.shape.currency.nullable(),
      repairStatus: repairInfoFragment.shape.repairStatus.nullable()
    }).shape,
    dealerNumber: operatorsModel.shape.dealerNumber,
    region: operatorsModel.shape.region,
    outfitterName: operatorsModel.shape.businessName,
    addressLine1: operatorAddressFragment.shape.addressLine1,
    addressLine2: operatorAddressFragment.shape.addressLine2,
    city: operatorAddressFragment.shape.city,
    stateProvince: operatorAddressFragment.shape.stateProvince,
    postalCode: operatorAddressFragment.shape.postalCode,
    vin: vehiclesModel.shape.vin,
    modelNumber: modelsModel.shape.modelNumber,
    modelYear: modelsModel.shape.modelYear,
    modelName: modelsModel.shape.modelName,
    involvedParties: involvedPartyModel
      .pick({
        name: true,
        involvement: true,
        phone: true,
        injured: true,
        medicalTreatmentProvided: true,
        injuryDescription: true
      })
      .array(),
    partOrders: partsOrderModel
      .pick({
        id: true,
        invoiceNumber: true,
        trackingNumber: true,
        invoiceTotal: true,
        orderStatus: true
      })
      .augment({ parts: partFragment.pick({ partNumber: true, quantity: true }).array() })
      .array(),
    createdByFirstName: z.string().nullable(),
    createdByLastName: z.string().nullable(),
    riskSpecialistFirstName: z.string().nullable(),
    riskSpecialistLastName: z.string().nullable()
  })

export type damageWaiverCaseReportView = z.infer<typeof damageWaiverCaseReportView>
